class MultipleVariants extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('.multiple-variants__form');
    this.submitBtn = this.querySelector('[data-role="submit"]');
    this.items = Array.from(
      this.querySelectorAll('.multiple-variants__item')
    );
    
    this.moneyFormat = window.Shopify?.money_format || '${{amount}}';

    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
    this.addEventListener('change', this.onChange);

    this.submitLabel = this.submitBtn.textContent.trim();
    this.updateState();
    
    this.submitBtn.addEventListener('click', this.onSubmit);
  
    this.replaceAddToCartButton();
    this.observeSellingPlanChanges();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('change', this.onChange);
    this.submitBtn.removeEventListener('click', this.onSubmit);
  }

  observeSellingPlanChanges() {
    document.addEventListener('change', (e) => {
      const target = e.target.closest('[name="selling_plan"], .rc-radio__input');

      if (!target) return;

      console.log('Selling plan changed, updating prices...');

      this.updateState();
    });
  }

  onClick(e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;

    const item = btn.closest('.multiple-variants__item');
    const input = item.querySelector('.qty-input');
    const max = parseInt(item.dataset.max, 10);
    let value = parseInt(input.value, 10) || 0;

    if (btn.dataset.action === 'increase') {
      value = Math.min(max, value + 1);
    }

    if (btn.dataset.action === 'decrease') {
      value = Math.max(0, value - 1);
    }

    if (value > 0) {
      item.classList.add('has-value');
    } else {
      item.classList.remove('has-value');
    }

    input.value = value;
    this.updateState();
  }

  onChange(e) {
    const input = e.target.closest('.qty-input');
    if (!input) return;

    const item = input.closest('.multiple-variants__item');
    const max = parseInt(item.dataset.max, 10);
    let value = parseInt(input.value, 10) || 0;

    if (value > 0) {
      item.classList.add('has-value');
    } else {
      item.classList.remove('has-value');
    }

    input.value = Math.max(0, Math.min(max, value));
    this.updateState();
  }

  updateState() {
    const totalPrice = this.calculateTotalPrice();
    const hasSelection = totalPrice > 0;

    this.submitBtn.disabled = !hasSelection;

    if (hasSelection) {
      this.submitBtn.textContent =
        `${this.submitLabel} · ${this.formatMoney(totalPrice)}`;
    } else {
      this.submitBtn.textContent = this.submitLabel;
    }
  }

  getSelectedSellingPlan() {
    return (
      document.querySelector('input[name="selling_plan"]:checked')?.value ||
      document.querySelector('input[type="hidden"][name="selling_plan"]')?.value ||
      document.querySelector('select[name="selling_plan"]')?.value ||
      null
    );
  }

  getVariantPrice(item) {
    const basePrice = parseInt(item.dataset.price, 10);
    const sellingPlans = JSON.parse(item.dataset.sellingPlans || '{}');
    const sellingPlanId = this.getSelectedSellingPlan();

    if (sellingPlanId && sellingPlans[sellingPlanId]) {
      return sellingPlans[sellingPlanId];
    }

    return basePrice;
  }

  replaceAddToCartButton() {
    const nativeAtcBtn = document.querySelector(
      'form[action="/cart/add"] [type="submit"], form[action="/cart/add"] [name="add"]'
    );

    if (!nativeAtcBtn) return;

    const wrapper = document.createElement('div');
    const clonedBtn = this.submitBtn.cloneNode(true);

    wrapper.style.display = 'contents';
    nativeAtcBtn.parentNode.insertBefore(wrapper, nativeAtcBtn);
    wrapper.appendChild(nativeAtcBtn);

    clonedBtn.disabled = this.submitBtn.disabled;
    clonedBtn.addEventListener('click', this.onSubmit);
    wrapper.appendChild(clonedBtn);
    nativeAtcBtn.remove();

    this.submitBtn = clonedBtn;
  }

  formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return this.moneyFormat.replace('{{amount}}', value);
  }

  calculateTotalPrice() {
    let total = 0;

    this.items.forEach(item => {
      const qty = parseInt(
        item.querySelector('.qty-input').value,
        10
      ) || 0;

      if (qty > 0) {
        const price = this.getVariantPrice(item);
        total += price * qty;
      }
    });

    return total;
  }

  async onSubmit() {
    const sellingPlan = this.getSelectedSellingPlan();
    const items = [];

    this.items.forEach(item => {
      const qty = parseInt(
        item.querySelector('.qty-input').value,
        10
      );

      if (qty > 0) {
        const payload = {
          id: item.dataset.variantId,
          quantity: qty
        };

        if (sellingPlan) {
          payload.selling_plan = sellingPlan;
        }

        items.push(payload);
      }
    });

    if (!items.length) return;

    this.submitBtn.disabled = true;

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    });

    this.items.forEach(item => {
      item.querySelector('.qty-input').value = 0;
      item.classList.remove('has-value');
    });
    this.updateState();

    document.dispatchEvent(
      new CustomEvent('cart:refresh')
    );
  }
}

customElements.define('multiple-variants', MultipleVariants);